document.addEventListener('DOMContentLoaded', function() {
  // récupère la description
  var desc = document.querySelector('.product__description.rte');
  if(desc) {
    desc.style.fontSize = '16px';
    desc.style.lineHeight = '1.3';
    desc.style.marginTop = '4px';
    desc.style.marginBottom = '4px';

    // applique aussi sur tous les paragraphes
    desc.querySelectorAll('p, li').forEach(function(el){
      el.style.fontSize = '18px';
      el.style.lineHeight = '1.3';
      el.style.marginBottom = '4px';
    });
  }
});
